<template>
  <div class="search">
    <div class="search-bar">
      <label for="" class="search-label">问题搜索：</label>
      <input
        type="search"
        class="search-input"
        placeholder="请填写要搜索的关键词"
        :value="value"
        @input="$emit('input', $event.target.value)">
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    key: function () {
      const key = this.value
      return key
    }
  },

}
</script>

<style lang="scss" scoped>
  .search {
    margin: 0 auto;
    padding: 30px;
    width: 830px;
    height: 110px;
    background: #e8e8e8;
  }

  .search-bar {
    line-height: 33px;
  }

  .search-label {
    font-weight: bold;
    font-size: 16px;
    color: #000;
  }

  .search-input {
    padding: 0 14px;
    width: 670px;
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    border-radius: 2px;
    border: 1px solid #D0D0D0;

    &::-webkit-input-placeholder {
      color: #d0d0d0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/page/help/components/search.vue